import { attendCode as workerAttendCode } from '@/constants';
import { DOCUMENT_NOT_SUBMITTED, NONE } from '@/constants/convictionStatus';
import { currency } from '@/utils';
export default class Worker {
    _useYn;
    _name;
    _type;
    _attendCode = null;
    _workTime;
    _phone;
    _carNumber;
    _hubId;
    _hubEmployeeNumber;
    _employeeType;
    _salaryType;
    _baromoney;
    _workerRegDate;
    _memo;
    _code;
    _hubDTO;
    _telNumber;
    _workerLeaveDate;
    _depositBaromoney;
    _socialNumber;
    _licenseNumber;
    _cardDeviceType;
    _orderDelayTimeSecond;
    _acceptedOrderViewLimitCount;
    _allocateLimitBaromoney;
    _maxAllocateCount;
    _minFinishMinuteAfterAllocated;
    _nowPickupCount;
    _nowAllocatedCount;
    _options;
    _workerDeliveryFeeGroupDTO;
    _workerCashAutoDeductGroupDTO;
    _workerPenaltyGroupDTO;
    _virtualBankCode;
    _virtualBankAccount;
    _withdrawalBankCode;
    _withdrawalBankAccount;
    _withdrawalBankOwner;
    _workerStatusContent;
    _homeAddress;
    workerStatusContent;
    _insuranceDepositDTO;
    convictionStatus;
    constructor({ useYn, name, type, attendCode, workTime, phone, carNumber, hubId, hubEmployeeNumber, employeeType, salaryType, baromoney, workerRegDate, memo, code, hubDTO, telNumber, workerLeaveDate, depositBaromoney, socialNumber, licenseNumber, cardDeviceType, orderDelayTimeSecond, acceptedOrderViewLimitCount, allocateLimitBaromoney, maxAllocateCount, minFinishMinuteAfterAllocated, nowPickupCount, nowAllocatedCount, options, workerDeliveryFeeGroupDTO, workerCashAutoDeductGroupDTO, workerPenaltyGroupDTO, virtualBankCode, virtualBankAccount, withdrawalBankCode, withdrawalBankAccount, withdrawalBankOwner, homeAddress, insuranceDepositDTO, convictionStatus, }) {
        this._useYn = useYn;
        this._name = name;
        this._type = type;
        this._attendCode = attendCode;
        this._workTime = workTime;
        this._phone = phone;
        this._carNumber = carNumber;
        this._hubId = hubId;
        this._hubEmployeeNumber = hubEmployeeNumber;
        this._employeeType = employeeType;
        this._salaryType = salaryType;
        this._baromoney = baromoney;
        this._workerRegDate = workerRegDate;
        this._memo = memo;
        this._code = code;
        this._hubDTO = hubDTO;
        this._telNumber = telNumber;
        this._workerLeaveDate = workerLeaveDate;
        this._depositBaromoney = depositBaromoney;
        this._socialNumber = socialNumber;
        this._licenseNumber = licenseNumber;
        this._cardDeviceType = cardDeviceType;
        this._orderDelayTimeSecond = orderDelayTimeSecond;
        this._acceptedOrderViewLimitCount = acceptedOrderViewLimitCount;
        this._allocateLimitBaromoney = allocateLimitBaromoney;
        this._maxAllocateCount = maxAllocateCount;
        this._minFinishMinuteAfterAllocated = minFinishMinuteAfterAllocated;
        this._nowPickupCount = nowPickupCount;
        this._nowAllocatedCount = nowAllocatedCount;
        this._options = options;
        this._workerDeliveryFeeGroupDTO = workerDeliveryFeeGroupDTO;
        this._workerCashAutoDeductGroupDTO = workerCashAutoDeductGroupDTO;
        this._workerPenaltyGroupDTO = workerPenaltyGroupDTO ?? {};
        this._virtualBankCode = virtualBankCode;
        this._virtualBankAccount = virtualBankAccount;
        this._withdrawalBankCode = withdrawalBankCode;
        this._withdrawalBankAccount = withdrawalBankAccount;
        this._withdrawalBankOwner = withdrawalBankOwner;
        this._workerStatusContent = this.workerStatusContent;
        this._homeAddress = homeAddress;
        this._insuranceDepositDTO = insuranceDepositDTO;
        // 프론트에서는 none이 필요 없기에 DOCUMENT_NOT_SUBMITTED로 변환
        this.convictionStatus = convictionStatus === NONE.key
            ? DOCUMENT_NOT_SUBMITTED.key
            : convictionStatus;
    }
    hubDTO;
    options;
    workerDeliveryFeeGroupDTO;
    workerCashAutoDeductGroupDTO;
    // 현재 픽업 건
    get nowPickupCount() {
        return this._nowPickupCount;
    }
    // 현재 배차 건
    get nowAllocatedCount() {
        return this._nowAllocatedCount;
    }
    // 라이더 상태
    get useYn() {
        return this._useYn;
    }
    // 라이더명
    get name() {
        return this._name;
    }
    // 라이더 유형
    get type() {
        return this._type;
    }
    // 운행 상태
    get attendCode() {
        return this._attendCode;
    }
    /**
     * 배차일 경우 운행으로 처리되는 리턴 값 (논의쓰레드: https://barogo.slack.com/archives/C04UP4VFCKA/p1681880644085769)
     * @return {Object} constant에 정의된 attendCode
     */
    get workerAttendCode() {
        if (this.attendCode === workerAttendCode.ALLOCATED.code) {
            return workerAttendCode[workerAttendCode.DRIVING.code];
        }
        return workerAttendCode[this.attendCode];
    }
    // 근무시간
    get workTime() {
        return this._workTime;
    }
    // 단말기번호
    get phone() {
        return this._phone;
    }
    // 대체연락처
    get telNumber() {
        return this._telNumber;
    }
    // 차량번호
    get carNumber() {
        return this._carNumber;
    }
    // 면허번호
    get licenseNumber() {
        return this._licenseNumber;
    }
    // 가상계좌은행코드
    get virtualBankCode() {
        return this._virtualBankCode;
    }
    // 라이더 가상 계좌번호
    get virtualBankAccount() {
        return this._virtualBankAccount;
    }
    // 출금계좌은행코드
    get withdrawalBankCode() {
        return this._withdrawalBankCode;
    }
    // 출금계좌번호
    get withdrawalBankAccount() {
        return this._withdrawalBankAccount;
    }
    // 출금계좌예금주
    get withdrawalBankOwner() {
        return this._withdrawalBankOwner;
    }
    // 소속허브 아이디
    get hubId() {
        return this._hubId;
    }
    // 소속허브명
    get hubName() {
        return this._hubDTO.name;
    }
    // 소속허브코드
    get hubCode() {
        return this._hubDTO.code;
    }
    // 사번
    get hubEmployeeNumber() {
        return this._hubEmployeeNumber;
    }
    // 고용형태
    get employeeType() {
        return this._employeeType;
    }
    // 보수 지급방식
    get salaryType() {
        return this._salaryType;
    }
    // 보유 바로머니
    get baromoney() {
        return this._baromoney;
    }
    get formattedBaromoney() {
        return currency(this.baromoney);
    }
    // 입사일
    get workerRegDate() {
        return this._workerRegDate;
    }
    // 퇴사일
    get workerLeaveDate() {
        return this._workerLeaveDate;
    }
    // 관리자 메모
    get memo() {
        return this._memo;
    }
    // 라이더 코드
    get code() {
        return this._code;
    }
    // 주소 (거주지 주소)
    get homeAddress() {
        return this._homeAddress;
    }
    // 예치금  = 허브설정 예치금
    get depositBaromoney() {
        return this._depositBaromoney;
    }
    get formattedDepositBaromoney() {
        return currency(this.depositBaromoney);
    }
    // 주민등록번호
    get socialNumber() {
        return this._socialNumber;
    }
    // 카드단말기
    get cardDeviceType() {
        return this._cardDeviceType;
    }
    // 락타임
    get orderDelayTimeSecond() {
        return this._orderDelayTimeSecond;
    }
    // 접수 목록 제한
    get acceptedOrderViewLimitCount() {
        return this._acceptedOrderViewLimitCount;
    }
    // 배차 제한잔액
    get allocateLimitBaromoney() {
        return this._allocateLimitBaromoney;
    }
    // 최대 배차 가능 건 수
    get maxAllocateCount() {
        return this._maxAllocateCount;
    }
    // 배차 후 완료가능 최소 시간
    get minFinishMinuteAfterAllocated() {
        return this._minFinishMinuteAfterAllocated;
    }
    // GPS 활성화
    get isForceGpsOn() {
        const { isForceGpsOn } = this._options;
        return isForceGpsOn;
    }
    // 공유배달 버튼
    get isSharedOrderHidden() {
        const { isSharedOrderHidden } = this._options;
        return isSharedOrderHidden;
    }
    // 배차취소 권한
    get isPossibleToCancelAllocatedOrder() {
        const { isPossibleToCancelAllocatedOrder } = this._options;
        return isPossibleToCancelAllocatedOrder;
    }
    // 픽업예정시간 수정 권한 (불가능에 대한 부정이 필요하기 때문에 부정값으로 출력)
    get isImpossibleToChangePickupExpectedAt() {
        const { isImpossibleToChangePickupExpectedAt } = this._options;
        return !isImpossibleToChangePickupExpectedAt;
    }
    // 도착지 주소 수정 권한
    get isPossibleToChangeDropAddress() {
        const { isPossibleToChangeDropAddress } = this._options;
        return isPossibleToChangeDropAddress;
    }
    // 결제수단 변경 권한
    get changePaymentAuthorityType() {
        const { changePaymentAuthorityType } = this._options;
        return changePaymentAuthorityType;
    }
    // 관제 권한
    get isPossibleToControl() {
        const { isPossibleToControl } = this._options;
        return isPossibleToControl;
    }
    // 상점 송금 권한
    get isPossibleToSendHubBaromoney() {
        const { isPossibleToSendHubBaromoney } = this._options;
        return isPossibleToSendHubBaromoney;
    }
    // 라이더 수수료 그룹 아이디
    get workerDeliveryFeeGroupId() {
        return this._workerDeliveryFeeGroupDTO?.id;
    }
    // 라이더 수수료 그룹 이름
    get workerDeliveryFeeGroupName() {
        if (this._workerDeliveryFeeGroupDTO && this._workerDeliveryFeeGroupDTO.name) {
            return this._workerDeliveryFeeGroupDTO.name;
        }
        return '-';
    }
    // 자동 차감 그룹 id
    get workerCashAutoDeductGroupId() {
        return this._workerCashAutoDeductGroupDTO?.id;
    }
    // 자동 차감 그룹 이름
    get workerCashAutoDeductGroupName() {
        if (this._workerCashAutoDeductGroupDTO && this._workerCashAutoDeductGroupDTO.name) {
            return this._workerCashAutoDeductGroupDTO.name;
        }
        return '-';
    }
    // 배차취소 패널티 그룹 id
    get workerPenaltyGroupId() {
        return this._workerPenaltyGroupDTO.id;
    }
    // 배차취소 패널티 그룹 이름
    get workerPenaltyGroupName() {
        if (this._workerPenaltyGroupDTO && this._workerPenaltyGroupDTO.name) {
            return this._workerPenaltyGroupDTO.name;
        }
        return '-';
    }
    // 고용/산재보험예치금의 합
    get totalInsuranceDepositBaromoney() {
        return this._insuranceDepositDTO?.totalInsuranceDepositBaromoney;
    }
    get formattedTotalInsuranceDepositBaromoney() {
        return currency(this.totalInsuranceDepositBaromoney);
    }
    // 고용보험 예치금
    get employeeInsuranceDepositBaromoney() {
        return this._insuranceDepositDTO?.employeeInsuranceDepositBaromoney;
    }
    get formattedEmployeeInsuranceDepositBaromoney() {
        return currency(this.employeeInsuranceDepositBaromoney);
    }
    // 산재보험 예치금
    get industrialAccidentInsuranceDepositBaromoney() {
        return this._insuranceDepositDTO?.industrialAccidentInsuranceDepositBaromoney;
    }
    get formattedIndustrialAccidentInsuranceDepositBaromoney() {
        return currency(this.industrialAccidentInsuranceDepositBaromoney);
    }
}
